import { Footer } from "@atomic";
import { NavigationProp } from "@react-navigation/native";
import React from "react";
import { ScrollView, View, useWindowDimensions, ViewStyle } from "react-native";

interface IProps {
  children?: React.ReactNode;
  navigation: NavigationProp<any>;
  style?: ViewStyle;
}

export const ScreenWithFooter = React.forwardRef<ScrollView, IProps>(({ children, navigation, style }, ref) => {
    const { height } = useWindowDimensions();
    return (
      <ScrollView
        ref={ref}
        contentContainerStyle={[
          {
            minHeight: height,
          },
          style,
        ]}
      >
        <View style={{ flex: 1 }}>{children}</View>
        <Footer navigation={navigation} />
      </ScrollView>
    );
});
